export type CountryCode = {
  country: string;
  text: string;
  value: string;
  code: string;
};

export default [
  {
    country: 'DK',
    text: '+45 (DK)',
    value: '+45',
    code: '45'
  },
  {
    country: 'SE',
    text: '+46 (SE)',
    value: '+46',
    code: '46'
  },
  {
    country: 'NO',
    text: '+47 (NO)',
    value: '+47',
    code: '47'
  },
  {
    country: 'DE',
    text: '+49 (DE)',
    value: '+49',
    code: '49'
  },
  {
    country: 'FI',
    text: '+358 (FI)',
    value: '+358',
    code: '358'
  },
  {
    country: 'GB',
    text: '+44 (GB)',
    value: '+44',
    code: '44'
  },
  {
    country: 'IS',
    text: '+354 (IS)',
    value: '+354',
    code: '354'
  },
  {
    country: 'BD',
    text: '+880 (BD)',
    value: '+880',
    code: '880'
  },
  {
    country: 'BE',
    text: '+32 (BE)',
    value: '+32',
    code: '32'
  },
  {
    country: 'BF',
    text: '+226 (BF)',
    value: '+226',
    code: '226'
  },
  {
    country: 'BG',
    text: '+359 (BG)',
    value: '+359',
    code: '359'
  },
  {
    country: 'BA',
    text: '+387 (BA)',
    value: '+387',
    code: '387'
  },
  {
    country: 'BB',
    text: '+1-246 (BB)',
    value: '+1-246',
    code: '1-246'
  },
  {
    country: 'WF',
    text: '+681 (WF)',
    value: '+681',
    code: '681'
  },
  {
    country: 'BL',
    text: '+590 (BL)',
    value: '+590',
    code: '590'
  },
  {
    country: 'BM',
    text: '+1-441 (BM)',
    value: '+1-441',
    code: '1-441'
  },
  {
    country: 'BN',
    text: '+673 (BN)',
    value: '+673',
    code: '673'
  },
  {
    country: 'BO',
    text: '+591 (BO)',
    value: '+591',
    code: '591'
  },
  {
    country: 'BH',
    text: '+973 (BH)',
    value: '+973',
    code: '973'
  },
  {
    country: 'BI',
    text: '+257 (BI)',
    value: '+257',
    code: '257'
  },
  {
    country: 'BJ',
    text: '+229 (BJ)',
    value: '+229',
    code: '229'
  },
  {
    country: 'BT',
    text: '+975 (BT)',
    value: '+975',
    code: '975'
  },
  {
    country: 'JM',
    text: '+1-876 (JM)',
    value: '+1-876',
    code: '1-876'
  },
  {
    country: 'BV',
    text: '+74 (BV)',
    value: '+74',
    code: '74'
  },
  {
    country: 'BW',
    text: '+267 (BW)',
    value: '+267',
    code: '267'
  },
  {
    country: 'WS',
    text: '+685 (WS)',
    value: '+685',
    code: '685'
  },
  {
    country: 'BQ',
    text: '+599 (BQ)',
    value: '+599',
    code: '599'
  },
  {
    country: 'BR',
    text: '+55 (BR)',
    value: '+55',
    code: '55'
  },
  {
    country: 'BS',
    text: '+1-242 (BS)',
    value: '+1-242',
    code: '1-242'
  },
  {
    country: 'JE',
    text: '+44-1534 (JE)',
    value: '+44-1534',
    code: '44-1534'
  },
  {
    country: 'BY',
    text: '+375 (BY)',
    value: '+375',
    code: '375'
  },
  {
    country: 'BZ',
    text: '+501 (BZ)',
    value: '+501',
    code: '501'
  },
  {
    country: 'RU',
    text: '+7 (RU)',
    value: '+7',
    code: '7'
  },
  {
    country: 'RW',
    text: '+250 (RW)',
    value: '+250',
    code: '250'
  },
  {
    country: 'RS',
    text: '+381 (RS)',
    value: '+381',
    code: '381'
  },
  {
    country: 'TL',
    text: '+670 (TL)',
    value: '+670',
    code: '670'
  },
  {
    country: 'RE',
    text: '+262 (RE)',
    value: '+262',
    code: '262'
  },
  {
    country: 'TM',
    text: '+993 (TM)',
    value: '+993',
    code: '993'
  },
  {
    country: 'TJ',
    text: '+992 (TJ)',
    value: '+992',
    code: '992'
  },
  {
    country: 'RO',
    text: '+40 (RO)',
    value: '+40',
    code: '40'
  },
  {
    country: 'TK',
    text: '+690 (TK)',
    value: '+690',
    code: '690'
  },
  {
    country: 'GW',
    text: '+245 (GW)',
    value: '+245',
    code: '245'
  },
  {
    country: 'GU',
    text: '+1-671 (GU)',
    value: '+1-671',
    code: '1-671'
  },
  {
    country: 'GT',
    text: '+502 (GT)',
    value: '+502',
    code: '502'
  },
  {
    country: 'GS',
    text: '+239 (GS)',
    value: '+239',
    code: '239'
  },
  {
    country: 'GR',
    text: '+30 (GR)',
    value: '+30',
    code: '30'
  },
  {
    country: 'GQ',
    text: '+240 (GQ)',
    value: '+240',
    code: '240'
  },
  {
    country: 'GP',
    text: '+590 (GP)',
    value: '+590',
    code: '590'
  },
  {
    country: 'JP',
    text: '+81 (JP)',
    value: '+81',
    code: '81'
  },
  {
    country: 'GY',
    text: '+592 (GY)',
    value: '+592',
    code: '592'
  },
  {
    country: 'GG',
    text: '+44-1481 (GG)',
    value: '+44-1481',
    code: '44-1481'
  },
  {
    country: 'GF',
    text: '+594 (GF)',
    value: '+594',
    code: '594'
  },
  {
    country: 'GE',
    text: '+995 (GE)',
    value: '+995',
    code: '995'
  },
  {
    country: 'GD',
    text: '+1-473 (GD)',
    value: '+1-473',
    code: '1-473'
  },
  {
    country: 'GA',
    text: '+241 (GA)',
    value: '+241',
    code: '241'
  },
  {
    country: 'SV',
    text: '+503 (SV)',
    value: '+503',
    code: '503'
  },
  {
    country: 'GN',
    text: '+224 (GN)',
    value: '+224',
    code: '224'
  },
  {
    country: 'GM',
    text: '+220 (GM)',
    value: '+220',
    code: '220'
  },
  {
    country: 'GL',
    text: '+299 (GL)',
    value: '+299',
    code: '299'
  },
  {
    country: 'GI',
    text: '+350 (GI)',
    value: '+350',
    code: '350'
  },
  {
    country: 'GH',
    text: '+233 (GH)',
    value: '+233',
    code: '233'
  },
  {
    country: 'OM',
    text: '+968 (OM)',
    value: '+968',
    code: '968'
  },
  {
    country: 'TN',
    text: '+216 (TN)',
    value: '+216',
    code: '216'
  },
  {
    country: 'JO',
    text: '+962 (JO)',
    value: '+962',
    code: '962'
  },
  {
    country: 'HR',
    text: '+385 (HR)',
    value: '+385',
    code: '385'
  },
  {
    country: 'HT',
    text: '+509 (HT)',
    value: '+509',
    code: '509'
  },
  {
    country: 'HU',
    text: '+36 (HU)',
    value: '+36',
    code: '36'
  },
  {
    country: 'HK',
    text: '+852 (HK)',
    value: '+852',
    code: '852'
  },
  {
    country: 'HN',
    text: '+504 (HN)',
    value: '+504',
    code: '504'
  },
  {
    country: 'HM',
    text: '+334  (HM)',
    value: '+334 ',
    code: '334'
  },
  {
    country: 'VE',
    text: '+58 (VE)',
    value: '+58',
    code: '58'
  },
  {
    country: 'PR',
    text: '+1-939 (PR)',
    value: '+1-939',
    code: '1-939'
  },
  {
    country: 'PS',
    text: '+970 (PS)',
    value: '+970',
    code: '970'
  },
  {
    country: 'PW',
    text: '+680 (PW)',
    value: '+680',
    code: '680'
  },
  {
    country: 'PT',
    text: '+351 (PT)',
    value: '+351',
    code: '351'
  },
  {
    country: 'SJ',
    text: '+47 (SJ)',
    value: '+47',
    code: '47'
  },
  {
    country: 'PY',
    text: '+595 (PY)',
    value: '+595',
    code: '595'
  },
  {
    country: 'IQ',
    text: '+964 (IQ)',
    value: '+964',
    code: '964'
  },
  {
    country: 'PA',
    text: '+507 (PA)',
    value: '+507',
    code: '507'
  },
  {
    country: 'PF',
    text: '+689 (PF)',
    value: '+689',
    code: '689'
  },
  {
    country: 'PG',
    text: '+675 (PG)',
    value: '+675',
    code: '675'
  },
  {
    country: 'PE',
    text: '+51 (PE)',
    value: '+51',
    code: '51'
  },
  {
    country: 'PK',
    text: '+92 (PK)',
    value: '+92',
    code: '92'
  },
  {
    country: 'PH',
    text: '+63 (PH)',
    value: '+63',
    code: '63'
  },
  {
    country: 'PN',
    text: '+870 (PN)',
    value: '+870',
    code: '870'
  },
  {
    country: 'PL',
    text: '+48 (PL)',
    value: '+48',
    code: '48'
  },
  {
    country: 'PM',
    text: '+508 (PM)',
    value: '+508',
    code: '508'
  },
  {
    country: 'ZM',
    text: '+260 (ZM)',
    value: '+260',
    code: '260'
  },
  {
    country: 'EH',
    text: '+212 (EH)',
    value: '+212',
    code: '212'
  },
  {
    country: 'EE',
    text: '+372 (EE)',
    value: '+372',
    code: '372'
  },
  {
    country: 'EG',
    text: '+20 (EG)',
    value: '+20',
    code: '20'
  },
  {
    country: 'ZA',
    text: '+27 (ZA)',
    value: '+27',
    code: '27'
  },
  {
    country: 'EC',
    text: '+593 (EC)',
    value: '+593',
    code: '593'
  },
  {
    country: 'IT',
    text: '+39 (IT)',
    value: '+39',
    code: '39'
  },
  {
    country: 'VN',
    text: '+84 (VN)',
    value: '+84',
    code: '84'
  },
  {
    country: 'SB',
    text: '+677 (SB)',
    value: '+677',
    code: '677'
  },
  {
    country: 'ET',
    text: '+251 (ET)',
    value: '+251',
    code: '251'
  },
  {
    country: 'SO',
    text: '+252 (SO)',
    value: '+252',
    code: '252'
  },
  {
    country: 'ZW',
    text: '+263 (ZW)',
    value: '+263',
    code: '263'
  },
  {
    country: 'SA',
    text: '+966 (SA)',
    value: '+966',
    code: '966'
  },
  {
    country: 'ES',
    text: '+34 (ES)',
    value: '+34',
    code: '34'
  },
  {
    country: 'ER',
    text: '+291 (ER)',
    value: '+291',
    code: '291'
  },
  {
    country: 'ME',
    text: '+382 (ME)',
    value: '+382',
    code: '382'
  },
  {
    country: 'MD',
    text: '+373 (MD)',
    value: '+373',
    code: '373'
  },
  {
    country: 'MG',
    text: '+261 (MG)',
    value: '+261',
    code: '261'
  },
  {
    country: 'MF',
    text: '+590 (MF)',
    value: '+590',
    code: '590'
  },
  {
    country: 'MA',
    text: '+212 (MA)',
    value: '+212',
    code: '212'
  },
  {
    country: 'MC',
    text: '+377 (MC)',
    value: '+377',
    code: '377'
  },
  {
    country: 'UZ',
    text: '+998 (UZ)',
    value: '+998',
    code: '998'
  },
  {
    country: 'MM',
    text: '+95 (MM)',
    value: '+95',
    code: '95'
  },
  {
    country: 'ML',
    text: '+223 (ML)',
    value: '+223',
    code: '223'
  },
  {
    country: 'MO',
    text: '+853 (MO)',
    value: '+853',
    code: '853'
  },
  {
    country: 'MN',
    text: '+976 (MN)',
    value: '+976',
    code: '976'
  },
  {
    country: 'MH',
    text: '+692 (MH)',
    value: '+692',
    code: '692'
  },
  {
    country: 'MK',
    text: '+389 (MK)',
    value: '+389',
    code: '389'
  },
  {
    country: 'MU',
    text: '+230 (MU)',
    value: '+230',
    code: '230'
  },
  {
    country: 'MT',
    text: '+356 (MT)',
    value: '+356',
    code: '356'
  },
  {
    country: 'MW',
    text: '+265 (MW)',
    value: '+265',
    code: '265'
  },
  {
    country: 'MV',
    text: '+960 (MV)',
    value: '+960',
    code: '960'
  },
  {
    country: 'MQ',
    text: '+596 (MQ)',
    value: '+596',
    code: '596'
  },
  {
    country: 'MP',
    text: '+1-670 (MP)',
    value: '+1-670',
    code: '1-670'
  },
  {
    country: 'MS',
    text: '+1-664 (MS)',
    value: '+1-664',
    code: '1-664'
  },
  {
    country: 'MR',
    text: '+222 (MR)',
    value: '+222',
    code: '222'
  },
  {
    country: 'IM',
    text: '+44-1624 (IM)',
    value: '+44-1624',
    code: '44-1624'
  },
  {
    country: 'UG',
    text: '+256 (UG)',
    value: '+256',
    code: '256'
  },
  {
    country: 'TZ',
    text: '+255 (TZ)',
    value: '+255',
    code: '255'
  },
  {
    country: 'MY',
    text: '+60 (MY)',
    value: '+60',
    code: '60'
  },
  {
    country: 'MX',
    text: '+52 (MX)',
    value: '+52',
    code: '52'
  },
  {
    country: 'IL',
    text: '+972 (IL)',
    value: '+972',
    code: '972'
  },
  {
    country: 'FR',
    text: '+33 (FR)',
    value: '+33',
    code: '33'
  },
  {
    country: 'IO',
    text: '+246 (IO)',
    value: '+246',
    code: '246'
  },
  {
    country: 'SH',
    text: '+290 (SH)',
    value: '+290',
    code: '290'
  },
  {
    country: 'FJ',
    text: '+679 (FJ)',
    value: '+679',
    code: '679'
  },
  {
    country: 'FK',
    text: '+500 (FK)',
    value: '+500',
    code: '500'
  },
  {
    country: 'FM',
    text: '+691 (FM)',
    value: '+691',
    code: '691'
  },
  {
    country: 'FO',
    text: '+298 (FO)',
    value: '+298',
    code: '298'
  },
  {
    country: 'NI',
    text: '+505 (NI)',
    value: '+505',
    code: '505'
  },
  {
    country: 'NL',
    text: '+31 (NL)',
    value: '+31',
    code: '31'
  },
  {
    country: 'NA',
    text: '+264 (NA)',
    value: '+264',
    code: '264'
  },
  {
    country: 'VU',
    text: '+678 (VU)',
    value: '+678',
    code: '678'
  },
  {
    country: 'NC',
    text: '+687 (NC)',
    value: '+687',
    code: '687'
  },
  {
    country: 'NE',
    text: '+227 (NE)',
    value: '+227',
    code: '227'
  },
  {
    country: 'NF',
    text: '+672 (NF)',
    value: '+672',
    code: '672'
  },
  {
    country: 'NG',
    text: '+234 (NG)',
    value: '+234',
    code: '234'
  },
  {
    country: 'NZ',
    text: '+64 (NZ)',
    value: '+64',
    code: '64'
  },
  {
    country: 'NP',
    text: '+977 (NP)',
    value: '+977',
    code: '977'
  },
  {
    country: 'NR',
    text: '+674 (NR)',
    value: '+674',
    code: '674'
  },
  {
    country: 'NU',
    text: '+683 (NU)',
    value: '+683',
    code: '683'
  },
  {
    country: 'CK',
    text: '+682 (CK)',
    value: '+682',
    code: '682'
  },
  {
    country: 'XK',
    text: '+383 (XK)',
    value: '+383',
    code: '383'
  },
  {
    country: 'CI',
    text: '+225 (CI)',
    value: '+225',
    code: '225'
  },
  {
    country: 'CH',
    text: '+41 (CH)',
    value: '+41',
    code: '41'
  },
  {
    country: 'CO',
    text: '+57 (CO)',
    value: '+57',
    code: '57'
  },
  {
    country: 'CN',
    text: '+86 (CN)',
    value: '+86',
    code: '86'
  },
  {
    country: 'CM',
    text: '+237 (CM)',
    value: '+237',
    code: '237'
  },
  {
    country: 'CL',
    text: '+56 (CL)',
    value: '+56',
    code: '56'
  },
  {
    country: 'CC',
    text: '+61 (CC)',
    value: '+61',
    code: '61'
  },
  {
    country: 'CA',
    text: '+1 (CA)',
    value: '+1',
    code: '1'
  },
  {
    country: 'CG',
    text: '+242 (CG)',
    value: '+242',
    code: '242'
  },
  {
    country: 'CF',
    text: '+236 (CF)',
    value: '+236',
    code: '236'
  },
  {
    country: 'CD',
    text: '+243 (CD)',
    value: '+243',
    code: '243'
  },
  {
    country: 'CZ',
    text: '+420 (CZ)',
    value: '+420',
    code: '420'
  },
  {
    country: 'CY',
    text: '+357 (CY)',
    value: '+357',
    code: '357'
  },
  {
    country: 'CX',
    text: '+61 (CX)',
    value: '+61',
    code: '61'
  },
  {
    country: 'CR',
    text: '+506 (CR)',
    value: '+506',
    code: '506'
  },
  {
    country: 'CW',
    text: '+599 (CW)',
    value: '+599',
    code: '599'
  },
  {
    country: 'CV',
    text: '+238 (CV)',
    value: '+238',
    code: '238'
  },
  {
    country: 'CU',
    text: '+53 (CU)',
    value: '+53',
    code: '53'
  },
  {
    country: 'SZ',
    text: '+268 (SZ)',
    value: '+268',
    code: '268'
  },
  {
    country: 'SY',
    text: '+963 (SY)',
    value: '+963',
    code: '963'
  },
  {
    country: 'SX',
    text: '+599 (SX)',
    value: '+599',
    code: '599'
  },
  {
    country: 'KG',
    text: '+996 (KG)',
    value: '+996',
    code: '996'
  },
  {
    country: 'KE',
    text: '+254 (KE)',
    value: '+254',
    code: '254'
  },
  {
    country: 'SS',
    text: '+211 (SS)',
    value: '+211',
    code: '211'
  },
  {
    country: 'SR',
    text: '+597 (SR)',
    value: '+597',
    code: '597'
  },
  {
    country: 'KI',
    text: '+686 (KI)',
    value: '+686',
    code: '686'
  },
  {
    country: 'KH',
    text: '+855 (KH)',
    value: '+855',
    code: '855'
  },
  {
    country: 'KN',
    text: '+1-869 (KN)',
    value: '+1-869',
    code: '1-869'
  },
  {
    country: 'KM',
    text: '+269 (KM)',
    value: '+269',
    code: '269'
  },
  {
    country: 'ST',
    text: '+239 (ST)',
    value: '+239',
    code: '239'
  },
  {
    country: 'SK',
    text: '+421 (SK)',
    value: '+421',
    code: '421'
  },
  {
    country: 'KR',
    text: '+82 (KR)',
    value: '+82',
    code: '82'
  },
  {
    country: 'SI',
    text: '+386 (SI)',
    value: '+386',
    code: '386'
  },
  {
    country: 'KP',
    text: '+850 (KP)',
    value: '+850',
    code: '850'
  },
  {
    country: 'KW',
    text: '+965 (KW)',
    value: '+965',
    code: '965'
  },
  {
    country: 'SN',
    text: '+221 (SN)',
    value: '+221',
    code: '221'
  },
  {
    country: 'SM',
    text: '+378 (SM)',
    value: '+378',
    code: '378'
  },
  {
    country: 'SL',
    text: '+232 (SL)',
    value: '+232',
    code: '232'
  },
  {
    country: 'SC',
    text: '+248 (SC)',
    value: '+248',
    code: '248'
  },
  {
    country: 'KZ',
    text: '+7 (KZ)',
    value: '+7',
    code: '7'
  },
  {
    country: 'KY',
    text: '+1-345 (KY)',
    value: '+1-345',
    code: '1-345'
  },
  {
    country: 'SG',
    text: '+65 (SG)',
    value: '+65',
    code: '65'
  },
  {
    country: 'SD',
    text: '+249 (SD)',
    value: '+249',
    code: '249'
  },
  {
    country: 'DO',
    text: '+1-809 (DO)',
    value: '+1-809',
    code: '1-809'
  },
  {
    country: 'DO',
    text: '+1-829 (DO)',
    value: '+1-829',
    code: '1-829'
  },
  {
    country: 'DO',
    text: '+1-849 (DO)',
    value: '+1-849',
    code: '1-849'
  },
  {
    country: 'DM',
    text: '+1-767 (DM)',
    value: '+1-767',
    code: '1-767'
  },
  {
    country: 'DJ',
    text: '+253 (DJ)',
    value: '+253',
    code: '253'
  },
  {
    country: 'VG',
    text: '+1-284 (VG)',
    value: '+1-284',
    code: '1-284'
  },
  {
    country: 'YE',
    text: '+967 (YE)',
    value: '+967',
    code: '967'
  },
  {
    country: 'DZ',
    text: '+213 (DZ)',
    value: '+213',
    code: '213'
  },
  {
    country: 'US',
    text: '+1 (US)',
    value: '+1',
    code: '1'
  },
  {
    country: 'UY',
    text: '+598 (UY)',
    value: '+598',
    code: '598'
  },
  {
    country: 'YT',
    text: '+262 (YT)',
    value: '+262',
    code: '262'
  },
  {
    country: 'UM',
    text: '+1 (UM)',
    value: '+1',
    code: '1'
  },
  {
    country: 'LB',
    text: '+961 (LB)',
    value: '+961',
    code: '961'
  },
  {
    country: 'LC',
    text: '+1-758 (LC)',
    value: '+1-758',
    code: '1-758'
  },
  {
    country: 'LA',
    text: '+856 (LA)',
    value: '+856',
    code: '856'
  },
  {
    country: 'TV',
    text: '+688 (TV)',
    value: '+688',
    code: '688'
  },
  {
    country: 'TW',
    text: '+886 (TW)',
    value: '+886',
    code: '886'
  },
  {
    country: 'TT',
    text: '+1-868 (TT)',
    value: '+1-868',
    code: '1-868'
  },
  {
    country: 'TR',
    text: '+90 (TR)',
    value: '+90',
    code: '90'
  },
  {
    country: 'LK',
    text: '+94 (LK)',
    value: '+94',
    code: '94'
  },
  {
    country: 'LI',
    text: '+423 (LI)',
    value: '+423',
    code: '423'
  },
  {
    country: 'LV',
    text: '+371 (LV)',
    value: '+371',
    code: '371'
  },
  {
    country: 'TO',
    text: '+676 (TO)',
    value: '+676',
    code: '676'
  },
  {
    country: 'LT',
    text: '+370 (LT)',
    value: '+370',
    code: '370'
  },
  {
    country: 'LU',
    text: '+352 (LU)',
    value: '+352',
    code: '352'
  },
  {
    country: 'LR',
    text: '+231 (LR)',
    value: '+231',
    code: '231'
  },
  {
    country: 'LS',
    text: '+266 (LS)',
    value: '+266',
    code: '266'
  },
  {
    country: 'TH',
    text: '+66 (TH)',
    value: '+66',
    code: '66'
  },
  {
    country: 'TF',
    text: '+262 (TF)',
    value: '+262',
    code: '262'
  },
  {
    country: 'TG',
    text: '+228 (TG)',
    value: '+228',
    code: '228'
  },
  {
    country: 'TD',
    text: '+235 (TD)',
    value: '+235',
    code: '235'
  },
  {
    country: 'TC',
    text: '+1-649 (TC)',
    value: '+1-649',
    code: '1-649'
  },
  {
    country: 'LY',
    text: '+218 (LY)',
    value: '+218',
    code: '218'
  },
  {
    country: 'VA',
    text: '+379 (VA)',
    value: '+379',
    code: '379'
  },
  {
    country: 'VC',
    text: '+1-784 (VC)',
    value: '+1-784',
    code: '1-784'
  },
  {
    country: 'AE',
    text: '+971 (AE)',
    value: '+971',
    code: '971'
  },
  {
    country: 'AD',
    text: '+376 (AD)',
    value: '+376',
    code: '376'
  },
  {
    country: 'AG',
    text: '+1-268 (AG)',
    value: '+1-268',
    code: '1-268'
  },
  {
    country: 'AF',
    text: '+93 (AF)',
    value: '+93',
    code: '93'
  },
  {
    country: 'AI',
    text: '+1-264 (AI)',
    value: '+1-264',
    code: '1-264'
  },
  {
    country: 'VI',
    text: '+1-340 (VI)',
    value: '+1-340',
    code: '1-340'
  },
  {
    country: 'IR',
    text: '+98 (IR)',
    value: '+98',
    code: '98'
  },
  {
    country: 'AM',
    text: '+374 (AM)',
    value: '+374',
    code: '374'
  },
  {
    country: 'AL',
    text: '+355 (AL)',
    value: '+355',
    code: '355'
  },
  {
    country: 'AO',
    text: '+244 (AO)',
    value: '+244',
    code: '244'
  },
  {
    country: 'AQ',
    text: '+672 (AQ)',
    value: '+672',
    code: '672'
  },
  {
    country: 'AS',
    text: '+1-684 (AS)',
    value: '+1-684',
    code: '1-684'
  },
  {
    country: 'AR',
    text: '+54 (AR)',
    value: '+54',
    code: '54'
  },
  {
    country: 'AU',
    text: '+61 (AU)',
    value: '+61',
    code: '61'
  },
  {
    country: 'AT',
    text: '+43 (AT)',
    value: '+43',
    code: '43'
  },
  {
    country: 'AW',
    text: '+297 (AW)',
    value: '+297',
    code: '297'
  },
  {
    country: 'IN',
    text: '+91 (IN)',
    value: '+91',
    code: '91'
  },
  {
    country: 'AX',
    text: '+358-18 (AX)',
    value: '+358-18',
    code: '358-18'
  },
  {
    country: 'AZ',
    text: '+994 (AZ)',
    value: '+994',
    code: '994'
  },
  {
    country: 'IE',
    text: '+353 (IE)',
    value: '+353',
    code: '353'
  },
  {
    country: 'ID',
    text: '+62 (ID)',
    value: '+62',
    code: '62'
  },
  {
    country: 'UA',
    text: '+380 (UA)',
    value: '+380',
    code: '380'
  },
  {
    country: 'QA',
    text: '+974 (QA)',
    value: '+974',
    code: '974'
  },
  {
    country: 'MZ',
    text: '+258 (MZ)',
    value: '+258',
    code: '258'
  }
] as CountryCode[];
